import COLORS from '../../../scss/colors.scss';

const CARD_GRAY = COLORS.gray7;

// TODO: pull this from ./constants
const titleXOffset = 28;

const updateSelectedNodeTree = (selectedNodes,canvas) => {
  canvas.nodesTag.update();
  for (let id of selectedNodes) {
    if (id && canvas.nodeTags[id]) {
      canvas.nodeTags[id].updateTopLevelNeighborsLite();
      canvas.nodeTags[id].updateLayers();
    }
  }
};


const updateDisplayProperties = (id,canvas,opts) => {
  const nodeTag = canvas.nodeTags[id];
  if (nodeTag && nodeTag.refs.container) {
    nodeTag.updatePosition();
    nodeTag.updateHiddenState();
    nodeTag.updateChildDisplayState();
    nodeTag.updateLinkNodeState();
    nodeTag.updateStyle();
    if (nodeTag.childNodesTag) {
      nodeTag.childNodesTag.updateDisplay();
    }
      // call this at the end to determine position & size after changing display properties
    nodeTag.discoverPosition();
    nodeTag.updateSearchResultDisplay();
  }
};

// refresh all freehand nodes from the bottom up
const refreshFreehandAncestorsOfList = (ids,canvas,store) => {
  for (const id of store.sortByDepth(ids)) {

    if (id === undefined || !store.getNode(id)) {
      continue;
    }

    if (canvas.nodeTags[id] && canvas.nodeTags[id].childNodesTag) {
      canvas.nodeTags[id].childNodesTag.fitToContents();
    }

    const list = store.getNode(id).ancestors();
    // don't repeat the same set of ancestors
    for (const n of list) {
      const nodeTag = canvas.nodeTags[n.id];

      if (nodeTag && nodeTag.childNodesTag) {
        // these ensure that nested freehand containers are sized properly
        nodeTag.childNodesTag.fitToContents();
        nodeTag.discoverPosition();
        if (nodeTag.childNodesTag) {
          nodeTag.childNodesTag.updateShadow();
        }
      }
    }
  }
};

// update view of pasted nodes and links
const updatePastedBatchDisplay = ({nodes,links,canvas}) => {
  canvas.nodesTag.update();
  canvas.linksTag.update();
  refreshFreehandAncestorsOfList(nodes.map(n => n.id), canvas, canvas.store);

  for (let node of nodes) {
    if (canvas.nodeTags[node.id]) {
      canvas.nodeTags[node.id].updateTopLevelNeighborsLite();
    }
  }
  canvas.searchModal.refreshResults();
  canvas.waypointsTabTag && canvas.waypointsTabTag.refreshIfNeeded();
  // TODO: assess whether we need to update links separately or if they're all accounted for via the node updates above
};

// remember to raise this when we can nest deeper than 5000 in a workable way.
const _iterationLimit = 5000;

const sortNodesByLineage = ({ nodes, store }) => {
  let sorted = [];
  const nodeIds = nodes.map(n => n.id);
  let nextIds = nodes.filter(n => !nodeIds.includes(n.parentId)).map(n => n.id);

  if (!nextIds.length) {
    return [];
  }

  let i = 0;
  while (sorted.length < nodes.length) {
    if (i >= _iterationLimit) {
      console.error('could not properly sort nodes by lineage');
      break;
    }
    sorted = sorted.concat(nodes.filter(n => nextIds.includes(n.id)));
    nextIds = nodes.filter(n => nextIds.includes(n.parentId)).map(n => n.id);
    i = i + 1;
  }
  return sorted;
};


const sanitizeText = text => {
  try {
    return text.replace(/(\r\n|\n|\r)/gm, "");
  } catch (e) {
    return '';
  }
};

const decodeHtml = html => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

const colorFromUserId = (id, alpha) => {

  const colors = {
    0: [239, 83, 80],
    1: [0, 105, 92],
    2: [255, 193, 7],
    3: [38, 198, 218],
    4: [94, 53, 177],
    5: [255, 128, 171],
    6: [68, 138, 255],
    7: [245, 124, 0],
    8: [156, 39, 176],
    9: [192, 202, 51],
    10: [56, 142, 60],
    11: [173, 20, 87],
  };
  let rgb;
  if (id) {
    rgb = colors[id % 11];
  } else {
    rgb = [173,173,173];
  }
  if (alpha) {
    return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${alpha})`;
  } else {
    return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
  }
};


function copyToClipboard({event, text, html='', plecticaJSON=''}) {

  if (event && event.clipboardData) {

    event.clipboardData.setData("text/plain", text);
    event.clipboardData.setData("text/html", html);
    event.clipboardData.setData("application/plectica", plecticaJSON);

  } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand("copy");  // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }
}

function convertNewlines(text) {
  if (text === undefined) {
    return;
  }
  return text.trim().replace(/(\r\n|\n|\r)/gm, '<br/>');
}

const getCookieValue = (cookie) => {
  if (!document) {
    throw new Error('not a document');
  }
  if (!cookie) {
    throw new Error('need a cookie');
  }

  const match = document.cookie.match(new RegExp(cookie + '=([^;]+)'));
  if (match && match[1]) {
    return match[1];
  } else {
    return false;
  }
};

const setCookie = ({key, value, expiration}) => {
  const cookieDate = new Date;
  //ten years
  cookieDate.setFullYear(cookieDate.getFullYear() + 10);

  if (!expiration) expiration = cookieDate;

  if (!document) {
    throw new Error('not a document');
  }
  document.cookie = `${key}=${value}; expires=${expiration}; path=/`;
};

const selectElementContents = el => {
  const range = document.createRange();
  range.selectNodeContents(el);
  const sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
};

function shade(hex, l) {
  let [r, g, b] = parseHex(hex);
  if (l < 0) {
    r = r * (1 + l);
    g = g * (1 + l);
    b = b * (1 + l);
  } else {
    r = (255 - r) * l + r | 0;
    g = (255 - g) * l + g | 0;
    b = (255 - b) * l + b | 0;
  }
  return stringifyHex(r, g, b);
}

function parseHex(h) {
  const r = parseInt(h.substring(1,3), 16);
  const g = parseInt(h.substring(3,5), 16);
  const b = parseInt(h.substring(5,7), 16);
  return [r, g, b];
}

function luminance(hex) {
  // https://www.w3.org/TR/AERT/#color-contrast
  const [r, g, b] = parseHex(hex);
  return (0.212 * r + 0.715 * g + 0.072 * b) / 255;
}

function stringifyHex(r, g, b) {
  return '#' + (b | (g << 8) | (r << 16)).toString(16).padLeft(6, '0');
}

function setEndOfContenteditable(contentEditableElement) {
  // based on https://gist.github.com/al3x-edge/1010364
  let range;
  let selection;
  if(document.createRange) {
    range = document.createRange();//Create a range (a range is a like the selection but invisible)
    range.selectNodeContents(contentEditableElement);//Select the entire contents of the element with the range
    range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
    selection = window.getSelection();//get the selection object (allows you to change selection)
    selection.removeAllRanges();//remove any selections already made
    selection.addRange(range);//make the range you have just created the visible selection
  }
}

function isColorGray(color) {
  return [
    'cardgray1',
    'cardgray2',
    'cardgray3',
    'cardgray4',
    'gray1',
    'gray2',
    'gray3',
    'gray4',
    'gray5',
    'gray6',
    'gray7',
    'gray8',
  ].findIndex(label => color === COLORS[label]) > -1;
}

function getAccentBorderColor(color) {
  switch (color) {
    case COLORS.gray4: return COLORS.gray4;
    case COLORS.gray5: return COLORS.gray5;
    case COLORS.gray6: return COLORS.gray6;
    case COLORS.gray7: return COLORS.gray7;
    default: return null;
  }
}

function getBorderColor(color) {
  switch (color) {
    case '#0471e1': return COLORS['blue3'];
    case COLORS['blue1']: return COLORS['blue3'];
    case COLORS['blue4']: return COLORS['blue3'];
    case COLORS['cyan']: return COLORS['cyan'];
    case COLORS['dk-cyan']: return COLORS['cyan'];
    case COLORS['dk-kiwi']: return COLORS['kiwi'];
    case COLORS['dk-orchid']: return COLORS['lt-orchid'];
    case COLORS['dk-pink']: return COLORS['pink'];
    case COLORS['dk-teal']: return COLORS['teal'];
    case COLORS['dk-yellow']: return COLORS['yellow'];
    case COLORS['fuchsia']: return COLORS['lt-fuchsia'];
    case COLORS['green']: return COLORS['lt-green'];
    case COLORS['kiwi']: return COLORS['kiwi'];
    case COLORS['orange']: return COLORS['lt-orange'];
    case COLORS['orchid']: return COLORS['lt-orchid'];
    case COLORS['pale-cyan']: return COLORS['cyan'];
    case COLORS['pale-green']: return COLORS['lt-green'];
    case COLORS['pale-kiwi']: return COLORS['kiwi'];
    case COLORS['pale-orange']: return COLORS['lt-orange'];
    case COLORS['pale-orchid']: return COLORS['lt-orchid'];
    case COLORS['pale-pink']: return COLORS['pink'];
    case COLORS['pale-red']: return COLORS['lt-red'];
    case COLORS['pale-teal']: return COLORS['teal'];
    case COLORS['pale-yellow']: return COLORS['yellow'];
    case COLORS['pink']: return COLORS['pink'];
    case COLORS['purple']: return COLORS['lt-purple'];
    case COLORS['red']: return COLORS['lt-red'];
    case COLORS['teal']: return COLORS['teal'];
    case COLORS['yellow']: return COLORS['yellow'];
    default: return color;
  }
}

function getAccentBackgroundColor(color) {
  switch (color) {
    case COLORS.gray4: return COLORS.cardgray1;
    case COLORS.gray5: return COLORS.cardgray2;
    case COLORS.gray6: return COLORS.cardgray3;
    case COLORS.gray7: return COLORS.cardgray4;
    case COLORS.fuchsia: return COLORS['pale-fuchsia'];
    case COLORS.red: return COLORS['pale-red'];
    case COLORS.green: return COLORS['pale-green'];
    case COLORS.orange: return COLORS['pale-orange'];
    case COLORS.teal: return COLORS['pale-teal'];
    case COLORS['dk-teal']: return COLORS['pale-teal'];
    case COLORS.purple: return COLORS['pale-purple'];
    case '#0471e1': return COLORS.blue1;
    case COLORS.blue4: return COLORS.blue1;
    case COLORS.yellow: return COLORS['pale-yellow'];
    case COLORS['dk-yellow']: return COLORS['pale-yellow'];
    case COLORS.pink: return COLORS['pale-pink'];
    case COLORS['dk-pink']: return COLORS['pale-pink'];
    case COLORS.kiwi: return COLORS['pale-kiwi'];
    case COLORS['dk-kiwi']: return COLORS['pale-kiwi'];
    case COLORS.cyan: return COLORS['pale-cyan'];
    case COLORS['dk-cyan']: return COLORS['pale-cyan'];
    case COLORS.orchid: return COLORS['pale-orchid'];
    case COLORS['dk-orchid']: return COLORS['pale-orchid'];
    default: return null;
  }
}

function getDarkColor(color) {
  switch (color) {
    case COLORS.gray4: return COLORS.gray5;
    case COLORS.gray5: return COLORS.gray5;
    case COLORS.gray6: return COLORS.gray5;
    case COLORS.gray7: return COLORS.gray5;
    case COLORS.fuchsia: return COLORS['dk-fuchsia'];
    case COLORS.red: return COLORS['dk-red'];
    case COLORS.green: return COLORS['dk-green'];
    case COLORS.orange: return COLORS['dk-orange'];
    case COLORS.teal: return COLORS['dk-teal'];
    case COLORS.purple: return COLORS['dk-purple'];
    case '#0471e1': return COLORS.blue5;
    case COLORS.blue4: return COLORS.blue5;
    case COLORS.yellow: return COLORS['dk-yellow'];
    case COLORS.pink: return COLORS['dk-pink'];
    case COLORS.kiwi: return COLORS['dk-kiwi'];
    case COLORS.cyan: return COLORS['dk-cyan'];
    case COLORS.orchid: return COLORS['dk-orchid'];
    default: return color;
  }
}

function getStyleColorVariables({ color, style }) {
  // we use default original colors if we have no color, or if we match the standard gray
  const isDefault = !color || (color == CARD_GRAY && style == 'standard');
  const isGray = isColorGray(color);

  if (isDefault) {
    color = CARD_GRAY;
  }

  const accentColor = getAccentBackgroundColor(color);
  const lightColor = style === 'accent' && accentColor ? accentColor : color;
  const darkColor = getDarkColor(color);
  let variables = `--base-color: ${color};
                   --light-color: ${lightColor};
                   --dark-color: ${darkColor};`;

  switch(style) {
    case 'accent': {
      variables += `--hatch-color: ${isGray ? shade(lightColor, -0.1) : shade(color, 0.6)};
                    --focus-color: ${shade(lightColor, -0.05)};
                    --border-color: ${isGray ? getAccentBorderColor(color) : getBorderColor(color)};
                    --blur-background-color: ${shade(shade(color, 0.5), -0.04)};
                    --freehand-card-background: ${shade(shade(lightColor, .5), -0.025)};
                    --white-freehand-card-background: ${shade(lightColor, .4)};`;

      if (luminance(lightColor) > 0.8) {
        variables += `--text-color: ${COLORS.gray7};`;
      } else {
        variables += `--text-color: white;`;
      }

      break;
    }
    case 'light': {
      variables += `--hatch-color: initial;
                    --focus-color: ${COLORS.gray2};
                    --blur-background-color: ${shade(COLORS.gray1, -0.02)};`;

      if (luminance(color) > 0.8) {
        variables += `--text-color: ${shade(color, -0.15)};`;
      } else {
        variables += `--text-color: ${color};`;
      }

      break;
    }
    case 'transparent': {
      variables += `--hatch-color: initial;
                    --focus-color: ${COLORS.gray2};
                    --blur-background-color: ${shade(COLORS.gray1, -0.02)};`;

      if (luminance(color) > 0.8) {
        variables += `--text-color: ${shade(color, -0.15)};`;
      } else {
        variables += `--text-color: ${color};`;
      }

      break;
    }
    default: {
      variables += `--focus-color: initial;
                    --blur-background-color: ${COLORS.gray1};`;

      if (isDefault) {
        variables += `--text-shadow-color: white;
                      --border-color: initial;
                      --hatch-color: ${COLORS.gray2};
                      --text-color: initial;`;
      } else {
        variables += `--hatch-color: ${shade(color, 0.8)};
                      --border-color: ${isGray ? 'initial' : getBorderColor(color)};`;

        if (luminance(color) > 0.8) {
          variables += `--text-color: ${shade(color, -0.1)};`;
        } else {
          variables += `--text-color: ${color};`;
        }
      }
    }
  }

  return variables;
}

function getTrackingLabel({ menuName }) {
  switch(menuName) {
    case 'node-menu':
      return 'Node Menu';
      break;
    case 'link-menu':
      return 'Link Menu';
      break;
    case 'node-image-menu':
      return 'Node Image Menu';
      break;
    case 'map-menu':
      return 'Map Menu';
      break;
    case 'right-click-menu':
      return 'Right Click Menu';
      break;
    case 'view-more-menu':
      return 'Toolbar Menu';
      break;
    case 'region-menu':
      return 'Region Menu';
      break;
    case 'toolbar':
      return 'Toolbar';
      break;
    default:
      return menuName;
  }
}


const scaleRect = ({ rect, canvas }) => {
  const { scale, tx, ty } = canvas.getMatrix();

  const newRect = {
    top: (rect.top - ty) / scale,
    bottom: (rect.bottom - ty) / scale,
    left: (rect.left - tx) / scale,
    right: (rect.right - tx) / scale,
    height: rect.height / scale,
    width: rect.width / scale
  };

  return newRect;
};

const unscaleRect = ({ rect, canvas }) => {
  const { scale, tx, ty } = canvas.getMatrix();

  const newRect = {
    top: rect.top * scale + ty,
    bottom: rect.bottom * scale + ty,
    left: rect.left * scale + tx,
    right: rect.right * scale + tx,
    height: rect.height * scale,
    width: rect.width * scale
  };

  return newRect;
};

const canPlayVideo = (type) => {
  if (type === 'video/quicktime') return true;
  const obj = document.createElement('video');
  return obj.canPlayType(type) === 'maybe';
};

const getFileIconColor = iconName => {
  const iconColorMap = {
    'file-pdf-icon': "#FA4545",
    'file-text-icon': '#0471E1',
    'file-presentation-icon': '#FA4545',
    'file-spreadsheet-icon': "#09A65F",
    'file-design-sketch-icon': "#FEA13A",
    'file-design-psd-icon': '#0471E1',
    'file-design-xd-icon': '#FF57BB',
    'file-design-icon' :'#ACB9C8',
    'file-code-css-icon': '#17BFF3',
    'file-code-sass-icon': '#FF57BB',
    'file-code-js-icon': '#FFBD08',
    'file-code-php-icon': '#5A19C0',
    'file-code-html-icon': '#E26D0B',
    'file-code-icon': '#ACB9C8',
    'file-audio-icon': '#FF57BB',
    'file-video-icon': '#FA4545',
    'file-image-icon': '#9658F7',
    'file-font-icon': '#ACB9C8',
    'file-compressed-icon': '#ACB9C8',
    'file-data-icon': "#ACB9C8",
    'file-default-icon': "#ACB9C8",
  };

  return iconColorMap[iconName];
};

const getIconNameFromExtension = extension => {
  extension = extension.slice(1).toLowerCase();

  if (extension === 'pdf') {
    return 'file-pdf-icon';
  } else if (['doc', 'docx', 'pages', 'rtf', 'txt'].includes(extension)) {
    return 'file-text-icon';
  } else if (['pps', 'ppt', 'pptx', 'key'].includes(extension)) {
    return 'file-presentation-icon';
  } else if (['.xls', 'xlsx', 'numbers'].includes(extension)) {
    return 'file-spreadsheet-icon';
  } else if (['sketch', 'psd', 'ai', 'xd','indd'].includes(extension)) {
    if (extension === 'sketch') {
      return 'file-design-sketch-icon';
    } else if (extension === 'psd') {
      return 'file-design-psd-icon';
    } else if (extension === 'xd') {
      return 'file-design-xd-icon';
    } else {
      return 'file-design-icon';
    }
  } else if (['xml', 'html', 'css', 'scss', 'sass', 'less', 'js', 'php', 'jsx'].includes(extension)) {
    if (extension === 'css') {
      return 'file-code-css-icon';
    } else if (['scss', 'sass'].includes(extension)) {
      return 'file-code-sass-icon';
    } else if (['js', 'jsx'].includes(extension)) {
      return 'file-code-js-icon';
    } else if (extension === 'php') {
      return 'file-code-php-icon';
    } else if (extension === 'html') {
      return 'file-code-html-icon';
    } else {
      return 'file-code-icon';
    }
  } else if (['mp3', 'm4a', 'wav', 'wma', 'mpa', 'flac', 'ogg', 'aac', 'alac'].includes(extension)) {
    return 'file-audio-icon';
  } else if (['flv', 'mov', 'mp4', 'mpg', 'wmv', 'mkv', 'avi'].includes(extension)) {
    return 'file-video-icon';
  } else if (['gif', 'jpg', 'png', 'eps', 'svg', 'tiff', 'jpeg'].includes(extension)) {
    return 'file-image-icon';
  } else if (['woff', 'woff2', 'ttf', 'otf'].includes(extension)) {
    return 'file-font-icon';
  } else if(['zip', 'rar', '7z', 'tar', 'gz'].includes(extension)) {
    return 'file-compressed-icon';
  } else if(['csv', 'dat', 'json', 'yml'].includes(extension)) {
    return 'file-data-icon';
  } else {
    return 'file-default-icon';
  }

};


const getVideoDimensions = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = e => {
      const video = document.createElement('video');

      video.addEventListener("loadedmetadata", function (e) {
        const width = this.videoWidth;
        const height = this.videoHeight;
        resolve({ width, height });
      }, false);

      //if we can't load the video, resolve with a default resolution (720p);
      setTimeout(() => resolve({ width: 1280, height: 720 }), 1000);

      if (file.type === 'video/quicktime') {
        //weird quicktime hack
        //https://discussions.apple.com/thread/5842398
        const frontMatter = e.target.result.slice(0, 50);
        const regex = /quicktime/gi;
        const newFrontMatter = frontMatter.replace(regex, 'mp4');
        video.src = `${newFrontMatter}${e.target.result.slice(50)}`;
      } else {
        video.src = e.target.result;
      }
    };

    reader.readAsDataURL(file);
  });
};

const animationFrame = () => {
  let resolve = null;
  const promise = new Promise(r => resolve = r);
  window.requestAnimationFrame(resolve);
  return promise;
};

const sleep = async (ms) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(), ms);
  });
};

const between = (number, bound1, bound2) => {
  const min = Math.min.apply(Math, [bound1, bound2]);
  const max = Math.max.apply(Math, [bound1, bound2]);
  return number > min && number < max;
};

const closest = (comparison , options) => {
  let best = options[0];

  let bestDist = comparison - options[0];

  for (const option of options.slice(1)) {
    if (Math.abs(comparison - option) < bestDist) {
      bestDist = Math.abs(comparison - option);
      best = option;
    }
  }
  return best;
};

module.exports = {
  convertNewlines,
  canPlayVideo,
  updateSelectedNodeTree,
  updateDisplayProperties,
  refreshFreehandAncestorsOfList,
  updatePastedBatchDisplay,
  sanitizeText,
  decodeHtml,
  colorFromUserId,
  sortNodesByLineage,
  copyToClipboard,
  getCookieValue,
  setCookie,
  selectElementContents,
  shade,
  setEndOfContenteditable,
  parseHex,
  luminance,
  getStyleColorVariables,
  getTrackingLabel,
  scaleRect,
  getIconNameFromExtension,
  getVideoDimensions,
  unscaleRect,
  animationFrame,
  sleep,
  between,
  closest,
  getFileIconColor,
};



// WEBPACK FOOTER //
// ./starling/src/lib/util.js